import * as Actions from '../../../Modules/CmsActions'
import type { ILead } from './UILeadReducer'

export interface IList {
  list: {
    id: number
    workspace_id: number
    cms_admin_id: number
    name: string
    type: string
    display_field_orders: []
    created_at: string
    updated_at: string
    leads: ILead[]
    filter_conditions?: {
      id: number
      list_id: number
      created_at: string
      updated_at: string
      conditions: {
        key: string
        value: string
        type: string
        expression: string
      }[]
    }[]
  }
  lead: ILead[]
  downloading: boolean
  loading: boolean
  pagination?: {
    current_page: number
    first_page_url: string | null
    from: number
    last_page: number
    last_page_url: string | null
    next_page_url: string | null
    path: string | null
    per_page: number
    prev_page_url: string | null
    to: number
    total: number
  }
}

const initialState = {
  loading: false,
  list: [],
}

const UIListReducer = (state = initialState, action) => {
  const { type, payload, error } = action

  switch (type) {
    case Actions.REQUEST_SEARCH_LEAD_FOR_LIST:
      return {
        ...state,
        loading: true,
      }

    case Actions.FINISH_SEARCH_LEAD_FOR_LIST:
      return {
        ...state,
        lead: payload.users,
        filteringQuery: payload.filteringQuery,
        loading: false,
        pagination: payload.pagination,
      }

    case Actions.REQUEST_GET_LISTS:
      return {
        ...state,
        loading: true,
      }

    case Actions.FINISH_GET_LISTS:
      return {
        list: payload.lists,
        loading: false,
        pagination: payload.pagination,
      }

    case Actions.REQUEST_FIND_LIST:
      return {
        ...state,
        loading: true,
      }

    case Actions.FINISH_FIND_LIST:
      return {
        list: payload.list,
        loading: false,
      }

    case Actions.REQUEST_CSV_DOWNLOAD_LIST:
      return {
        ...state,
        downloading: true,
      }

    case Actions.FINISH_CSV_DOWNLOAD_LIST:
      return {
        ...state,
        downloading: false,
      }

    case Actions.FINISH_LIST_LOAD:
      return {
        ...state,
        loading: false,
      }

    default:
      return state
  }
}

export default UIListReducer
